import { faLockAlt } from '@fortawesome/pro-light-svg-icons';
import { faGridRound } from '@fortawesome/sharp-light-svg-icons';
import { useTranslation } from 'react-i18next';

import { colours } from '../../../assets/colours';
import ChevronBackBtn from '../../../shared/components/styledComponents/chevronBackBtn/ChevronBackBtn';
import { MenuOptionButton } from '../../components/menuOptionButton/MenuOptionButton';

type SecurityLeftMenuProps = {
  activeSubMenu: { id: number };
  profile: any;
  changeMenu: (arg0: number, arg1: string) => void;
  changeSubMenu: (arg0: number) => void;
};

export function SecurityLeftMenu({
  activeSubMenu,
  profile,
  changeMenu,
  changeSubMenu,
}: SecurityLeftMenuProps) {
  const { t } = useTranslation();

  return (
    profile && (
      <>
        <div className="profile-settings-btn-cont">
          <ChevronBackBtn onClick={() => changeMenu(0, 'back')} />
        </div>

        <MenuOptionButton
          role="button"
          id="menu-option-button-1"
          icon={faLockAlt}
          color={colours.yellow}
          text={t('S026')}
          onClick={() => changeSubMenu(1)}
          isActive={activeSubMenu?.id === 52}
        />

        <MenuOptionButton
          role="button"
          id="menu-option-button-2"
          icon={faGridRound}
          color={colours.yellow}
          text={t('S028')}
          onClick={() => changeSubMenu(2)}
          isActive={activeSubMenu?.id === 53}
        />
      </>
    )
  );
}
